import React from 'react';
import { MainWrapper } from '../main-wrapper';
import { IAPIStudioInfo } from '../../../model/api-modules';
import { IComponentProps } from '../../../model/studio';
import { PortalContentComponent } from './portal-content';
import getFormatMessage from '../../../locales/get-format-message';
import styles from './index.module.scss';

export const PortalRouter = () => {
  const renderCustomTitle = (studioInfo: IAPIStudioInfo | null) => {
    return studioInfo?.studio.Name;
  };

  const renderComponent = (props: IComponentProps) => {
    return <PortalContentComponent {...props} />;
  };

  return (
    <MainWrapper
      className={styles.portalPage}
      title={getFormatMessage('portal')}
      renderComponent={renderComponent}
      renderCustomTitle={renderCustomTitle}
    />
  );
};
